import { useModal } from 'vue-final-modal';

import { LazyModalsContact } from '#components';

const { open, close, isOpen } = useModal({
  component: LazyModalsContact,
});

export const useContactModal = () => ({
  openContactModal: open,
  close,
  isOpen,
});
